import React from "react";

import {
    useUserNotificationCenter,
    useUserNotificationCenterDispatcher,
} from "../../../common/component/notifications/notification-center/user-notification-center-context-provider";
import { Badge, Button, Tooltip } from "@mui/material";
import { t } from "i18next";
import { Notifications } from "@mui/icons-material";

export const NotificationWidget = () => {
    const notificationCenter = useUserNotificationCenter();
    const notificationCenterDispatcher = useUserNotificationCenterDispatcher();

    const handleNotificationCenterOpen = () => {
        notificationCenterDispatcher({
            type: "open",
        });
    };

    return <>
        <Tooltip title={t("components.notificationCenter.widget.description")}>
            <Badge color={"primary"}
                   badgeContent={notificationCenter.unreadNotificationsCount}
                   invisible={notificationCenter.unreadNotificationsCount === 0}>
                <Button variant={"outlined"}
                        color={"inherit"}
                        onClick={handleNotificationCenterOpen}
                        size={"large"}>
                    <Notifications />
                </Button>
            </Badge>
        </Tooltip>
    </>;
};
